<ng-template #loading>
  <app-data-loader [isLoading] = "true" [diameter] = "90"></app-data-loader>
</ng-template>  
<div *ngIf="loanMeta$ | async; else loading" class="loan-meta-layout" style="padding: 30px;">
  <!-- Full-width summary above the notes and tabs -->
  <mat-card class="content-card loan-summary-shell">
    <button mat-button color="primary" class="loan-summary-rail loan-summary-rail--prev"
      *ngIf="isQueued" aria-label="Previous loan" (click)="previousLoan()"
      [disabled]="!loanMetaService.canGoPrevious">
      <mat-icon>chevron_left</mat-icon>
    </button>
    <mat-accordion class="loan-summary-accordion">
      <mat-expansion-panel class="loan-summary-panel mat-elevation-z0" [(expanded)]="panelOpenState">
        <mat-expansion-panel-header class="loan-summary-header"
          collapsedHeight="auto" expandedHeight="auto">
          <mat-panel-title class="loan-summary-title">
            <h4 class="loan-summary-name">
              <a [routerLink]="externalRole ? [] : [
                '/applications/summary/',
                collection_info?.cifnumber
              ]">{{ collection_info?.Name }}</a>
              <span class="loan-summary-number">{{ collection_info?.Loan_Number }}</span>
            </h4>
          </mat-panel-title>
          <mat-panel-description class="loan-summary-collector">
            <span class="summary-label">Assigned Collector</span>
            <span class="summary-value">{{ collection_info?.['assigned_collector'] }}</span>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <div class="summary-grid">
          <div class="summary-item">
            <span class="summary-label">Maturity Date</span>
            <span class="summary-value">{{ meta?.maturity_date }}</span>
          </div>
          <div class="summary-item">
            <span class="summary-label">Total Balance</span>
            <span class="summary-value" [class.summary-value--warn]="isMatured">{{ totalBalance | currency }}</span>
          </div>
          <div class="summary-item" *ngIf="!isMatured">
            <span class="summary-label">Past Due</span>
            <span class="summary-value">${{ meta?.total_due }}</span>
          </div>
          <div class="summary-item">
            <span class="summary-label">DPD</span>
            <span class="summary-value">{{ collection_info?.Days_Missed }}</span>
          </div>
          <div class="summary-item">
            <span class="summary-label">Unbilled Interest</span>
            <span class="summary-value">${{ unbilledInterest }}</span>
          </div>
          <div class="summary-item">
            <span class="summary-label">Scheduled Amount</span>
            <span class="summary-value">${{ meta?.amortized_payment_amount }}</span>
          </div>
          <div class="summary-item">
            <span class="summary-label">Status</span>
            <span class="summary-value">{{ meta?.loan_status }}</span>
          </div>
          <div class="summary-item">
            <span class="summary-label" (dblclick)="statusUpdate()">Status Codes</span>
            <span class="summary-value">{{ meta?.status_code }}</span>
          </div>
          <div class="summary-item">
            <span class="summary-label">Loan Group</span>
            <span class="summary-value">{{ meta?.loan_group }}</span>
          </div>
        </div>

        <mat-action-row class="summary-actions">
          <div class="summary-links">
            <button mat-button color="primary" (click)="openTransunion()"
              matTooltip="Click to View Credit Bureau">Credit Bureau</button>
            <button mat-button color="primary" (click)="openWorkDrive()"
              matTooltip="Click to View Documents">Documents</button>
          </div>
        </mat-action-row>
      </mat-expansion-panel>
    </mat-accordion>
    <button mat-button color="primary" class="loan-summary-rail loan-summary-rail--next"
      *ngIf="isQueued" aria-label="Next loan" (click)="nextLoan()"
      [disabled]="!loanMetaService.canGoNext">
      <mat-icon>chevron_right</mat-icon>
    </button>
  </mat-card>
  <!-- Tabs and notes grow with their content; the page scrolls -->
  <div class="loan-meta-body">
    <aside class="loan-meta-notes" [class.loan-meta-notes--collapsed]="!notesOpen">
      <!-- Toggles the notes; stays visible when collapsed -->
      <button mat-button color="primary" class="sidenav-toggle-button" (click)="notesOpen = !notesOpen; toggleSideNav()"
        [attr.aria-label]="notesOpen ? 'Hide notes' : 'Show notes'"
        [ngClass]="isSideNavMenuOpen ? 'sidenav-open' : 'sidenav-closed'">
        <i class="fa fa-angle-double-right fa-lg" aria-hidden="true"
          [@sideNavMenuAnimationState]="isSideNavMenuOpen ? 'right' : 'left'"></i>
      </button>
      <div class="loan-meta-notes-content" [hidden]="!notesOpen">
        <mat-card appearance="outlined" style="padding: 10px; position: relative;">
          <h5>Add Note</h5>
          <div style="float: left; display: flex">
            <div>
              <mat-form-field appearance="outline" style="font-weight: bold;">
                <mat-label>Comment Type</mat-label>
                <mat-select [(ngModel)]="selectedType" (selectionChange)="displayEmails(selectedType)">
                  <mat-option *ngFor=" let ct of comment_types" [value]="ct.value">
                    {{ ct.viewValue }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div style="padding-left: 4px; width: 100%;">
              <mat-form-field appearance="outline" style="font-weight: bold; width: 100%;">
                <mat-label>Disposition</mat-label>
                <mat-select [(ngModel)]="selectedType_d">
                  <mat-option *ngFor="let d of dispositions" [value]="d.name">
                    {{ d.id }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div *ngIf="selectedType === 'Email Notes' && selectedType_d === 'Internal Email'">
            <mat-form-field appearance="outline" style="font-weight: bold; width: 100%;">
              <mat-label>Select an email address</mat-label>
              <mat-select [(ngModel)]="selectedEmail">
                <mat-option *ngFor="let item of officeEmails" [value]="item.email_addresses">
                  {{ item.email_addresses }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div>
	          <mat-form-field appearance="outline" style="width: 100%">
              <textarea matInput name="Comments" placeholder="Comments"
                [(ngModel)]="comment"></textarea>
              </mat-form-field>
          </div>
          <div>
            <button mat-raised-button color="primary" style="width: 150px;"
              (click)="createComment()">Save</button>
          </div>
        </mat-card>
        <div>
          <mat-card-content class="scrollable-card-content">
            <table mat-table [dataSource]="notesDataSource()" class="flat-table mat-elevation-z0">
                <ng-container matColumnDef="created">
                    <th style="width: 110px;" mat-header-cell *matHeaderCellDef> Created </th>
                    <td style="width: 110px; vertical-align: top;" mat-cell *matCellDef="let element"> {{ element?.created_at }} </td>
                </ng-container>
                <ng-container matColumnDef="note">
                    <th mat-header-cell *matHeaderCellDef> Note </th>
                    <td mat-cell *matCellDef="let element" style="text-align: justify;"><strong>{{ element?.type }} [{{ element?.disposition }}] -
                    {{ element?.created_by.split('@')[0] }}</strong><br />{{ element?.comment }}<span
                    *ngIf="element?.email_sent_to"><br /><strong>Emailed:</strong> {{
                    element?.email_sent_to }}</span> </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="noteCols; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: noteCols;" (dblclick)="openCommentForm(row)"></tr>
            </table>
            <mat-paginator
              [length]="Comments_table?.length"
              [pageSize]="count"
              [pageIndex]="p - 1"
              [pageSizeOptions]="[5, 10, 20, 50]"
              (page)="onPageChange($event)"
              showFirstLastButtons>
            </mat-paginator>
          </mat-card-content>
        </div>
      </div>
    </aside>
    <div class="loan-meta-main">
      <div>
        <div>
          <!-- <mat-tab-group (selectedTabChange)="selectedTabValue($event)"> -->
            <mat-tab-group (selectedTabChange)="selectedTabValue($event)">
            <mat-tab label="Details"> 
              <div style="margin-bottom: 1em;">
                <mat-card class="simple-card" style="width: 100%;">                  
                  <mat-card-content > 
                    <div>
                      <h3 style="text-transform: uppercase; color: #5c7192;">Client Information</h3>
                      <div class="client-info-grid">
                        <div>                          
                          <label style="font-weight: bold;">Short Name</label>
                          <p class="p-style">{{ collection_info?.shortName }}</p>
                        </div>
                        <div>                          
                          <label style="font-weight: bold;">Address</label>
                          <p class="p-style">{{ collection_info?.Address }}</p>
                        </div>
                        <div>                          
                          <label style="font-weight: bold;">City</label>
                          <p class="p-style">{{ collection_info?.City }}</p>
                        </div>
                        <div>                          
                          <label style="font-weight: bold;">Province</label>
                          <p class="p-style">{{ collection_info?.Province }}</p>
                        </div>
                        <div>                          
                          <label style="font-weight: bold;">Postal Code</label>
                          <p class="p-style">{{ collection_info?.Postal_Code }}</p>
                        </div>
                        <div>                          
                          <label style="font-weight: bold;">Phone Number</label>
                          <p class="p-style">{{ collection_info?.Phone_No }}</p>
                        </div>
                        <div>                          
                          <label style="font-weight: bold;">Email</label>
                          <p class="p-style">{{ collection_info?.Email }}</p>
                        </div>
                        <div>                          
                          <label style="font-weight: bold;">DOB</label>
                          <p class="p-style">{{ collection_info?.DOB }}</p>
                        </div>
                        <div>                          
                          <label style="font-weight: bold;">Emergency Contact</label>
                          <p class="p-style">{{ collection_info?.['EmergencyContact'] }}</p>
                        </div>
                      </div>
                    </div>                    
                  </mat-card-content>
                </mat-card>
              </div>
              <div style="display: grid; grid-template-columns: 1fr 2fr; grid-column-gap: 10px; grid-row-gap: 10px; margin-bottom: 1em;">
                <mat-card class="simple-card">                  
                  <mat-card-content >                       
                    <h3 style="text-transform: uppercase; color: #5c7192;">Balance as of {{test_date | date:'yyyy-MM-dd'}}</h3>                    
                      <div style="display: grid; grid-template-columns: repeat(2, 1fr); grid-column-gap: 10px; grid-row-gap: 10px;">
                        <div>                          
                          <label style="font-weight: bold;">Principal</label>
                          <p class="p-style">{{ collection_info?.current_principal_balance | currency }}</p>
                        </div>
                        <div>                          
                          <label style="font-weight: bold;">Interest</label>
                          <p class="p-style">{{ (collection_info?.current_interest_balance)?.toFixed(2) | currency}}</p>
                        </div>
                        <div>                          
                          <label style="font-weight: bold;">Fees</label>
                          <p class="p-style">{{meta?.eff_fees_balance | currency}}</p>
                        </div>
                        <div>                          
                          <label style="font-weight: bold;">Insurance</label>
                          <p class="p-style">{{meta?.insurance | currency}}</p>
                        </div>
                      </div>                    
                    </mat-card-content>
                </mat-card>
                <mat-card class="simple-card">                  
                  <mat-card-content >   
                    <h3 style="text-transform: uppercase; color: #5c7192">Loan Information</h3>
                    <div style="display: grid; grid-template-columns: repeat(4, 1fr); grid-column-gap: 10px; grid-row-gap: 10px;">
                      <div>                          
                          <label style="font-weight: bold;">Original Loan Amount</label>
                          <p class="p-style">{{collection_info?.original_note_amount | currency}}</p>
                        </div>
                        <div>                          
                          <label style="font-weight: bold;">Open Date</label>
                          <p class="p-style">{{ meta?.open_date }}</p>
                        </div>
                        <div>                          
                          <label style="font-weight: bold;">Total Obligation (est)</label>
                          <p class="p-style">{{total_obligation_entire_term.toLocaleString('en-US') | currency }}</p>
                        </div>
                        <div>                          
                          <label style="font-weight: bold;">Origination Date</label>
                          <p class="p-style">{{ meta?.origination_date }}</p>
                        </div>
                        <div>                          
                          <label style="font-weight: bold;">Maturity Date</label>
                          <p class="p-style">{{ meta?.maturity_date }}</p>
                        </div>
                        <div>                          
                          <label style="font-weight: bold;">Closed Date</label>
                          <p class="p-style">{{ meta?.closed_date }}</p>
                        </div>
                        <div>                          
                          <label style="font-weight: bold;">Current Loan Amount</label>
                          <p class="p-style">{{collection_info?.current_note_amount | currency}}</p>
                        </div>
                        <div>                          
                          <label style="font-weight: bold;">Current Rate</label>
                          <p class="p-style">{{ meta?.current_rate }}%</p>
                        </div>
                        <div>                          
                          <label style="font-weight: bold;">Per Diem</label>
                          <p class="p-style">${{ meta?.perdiem }}</p>
                        </div>   
                        <div>                          
                          <label style="font-weight: bold;">Payment Frequency</label>
                          <p class="p-style">{{ meta?.principal_period }}</p>
                        </div>   
                        <div>                          
                          <label style="font-weight: bold;">acctrefno</label>
                          <p class="p-style">{{ collection_info?.acctrefno }}</p>
                        </div>   
                    </div>                    
                    </mat-card-content>
                    </mat-card>
              </div>

              <div style="display: grid; grid-template-columns: 1fr 2fr; grid-column-gap: 10px; grid-row-gap: 10px;">
                <mat-card class="simple-card" style="width: 100%;">                  
                  <mat-card-content > 
                    <div class="details-item-top-right">
                      <h3 style="text-transform: uppercase; color: #5c7192;">Employment Information</h3>
                      <div style="display: grid; grid-template-columns: repeat(2, 1fr); grid-column-gap: 10px; grid-row-gap: 10px;">
                    <div>                          
                          <label style="font-weight: bold;">Work Phone</label>
                          <p class="p-style">{{ collection_info?.['Work Phone'] }}</p>
                        </div>
                        <div>                          
                          <label style="font-weight: bold;">Industry</label>
                          <p class="p-style">{{ collection_info?.['Industry'] }}</p>
                        </div>
                        <div>                          
                          <label style="font-weight: bold;">Employer</label>
                          <p class="p-style">{{ collection_info?.['Employer'] }}</p>
                        </div>
                        <div>                          
                          <label style="font-weight: bold;">Position</label>
                          <p class="p-style">{{ collection_info?.['Position'] }}</p>
                        </div>
                        <div>                          
                          <label style="font-weight: bold;">Additional Employment Info</label>
                          <p class="p-style">{{ collection_info?.['Additional Employment Info'] }}</p>
                        </div>
                        <div>                          
                          <label style="font-weight: bold;">Employemnt Status</label>
                          <p class="p-style">{{ collection_info?.['Employemnt Status'] }}</p>
                        </div>
                        <div>                          
                          <label style="font-weight: bold;">Supervisor Name</label>
                          <p class="p-style">{{ collection_info?.['Supervisor Name'] }}</p>
                        </div>
                        <div>                          
                          <label style="font-weight: bold;">Supervisor Phone</label>
                          <p class="p-style">{{ collection_info?.['Supervisor Phone'] }}</p>
                        </div>   
                        </div> 
                    </div>                    
                  </mat-card-content>
                </mat-card> 
                <mat-card class="simple-card">                  
                    <mat-card-content >  
                      <h3 style="text-transform: uppercase; color: #5c7192">Coapplicant Information</h3> 
                      <div style="display: grid; grid-template-columns: repeat(4, 1fr); grid-column-gap: 10px; grid-row-gap: 10px;">
                        <div>                          
                          <label style="font-weight: bold;">Co-Debtor First Name</label>
                          <p class="p-style">{{ collection_info?.['Co-Debtor First Name'] }}</p>
                        </div>
                        <div>                          
                          <label style="font-weight: bold;">Co-Debtor Middle Name</label>
                          <p class="p-style">{{ collection_info?.['Co-Debtor Middle Name'] }}</p>
                        </div>
                        <div>                          
                          <label style="font-weight: bold;">Co-Debtor Last Name</label>
                          <p class="p-style">{{ collection_info?.['Co-Debtor Last Name'] }}</p>
                        </div>
                        <div>                          
                          <label style="font-weight: bold;">Co-Debtor Address</label>
                          <p class="p-style">{{ collection_info?.['Co-Debtor Address'] }}</p>
                        </div>
                        <div>                          
                          <label style="font-weight: bold;">Co-Debtor City</label>
                          <p class="p-style">{{ collection_info?.['Co-Debtor City'] }}</p>
                        </div>
                        <div>                          
                          <label style="font-weight: bold;">Co-Debtor Province</label>
                          <p class="p-style">{{ collection_info?.['Co-Debtor Province'] }}</p>
                        </div>
                        <div>                          
                          <label style="font-weight: bold;">Co-Debtor Postal Code</label>
                          <p class="p-style">{{ collection_info?.['Co-Debtor Postal Code'] }}</p>
                        </div>
                        <div>                          
                          <label style="font-weight: bold;">Co-Debtor Phone Number</label>
                          <p class="p-style">{{ collection_info?.['Co-Debtor Phone Number'] }}</p>
                        </div>
                        <div>                          
                          <label style="font-weight: bold;">Co-Debtor DOB</label>
                          <p class="p-style">{{ collection_info?.['Co-Debtor DOB'] }}</p>
                        </div>
                        <div>                          
                          <label style="font-weight: bold;">Co-Debtor Email</label>
                          <p class="p-style">{{ collection_info?.['Co-Debtor Email'] }}</p>
                        </div>   
                        <div>                          
                          <label style="font-weight: bold;">Co-Debtor Employment Type</label>
                          <p class="p-style">{{ collection_info?.['Co-Debtor Employment Type'] }}</p>
                        </div>   
                        <div>                          
                          <label style="font-weight: bold;">Co-Debtor Employer</label>
                          <p class="p-style">{{ collection_info?.['Co-Debtor Employer'] }}</p>
                        </div>   
                        <div>                          
                          <label style="font-weight: bold;">Co-Debtor Occupation</label>
                          <p class="p-style">{{ collection_info?.['Co-Debtor Occupation'] }}</p>
                        </div>  
                        <div>                          
                          <label style="font-weight: bold;">Co-Debtor Supervisor Name</label>
                          <p class="p-style">{{ collection_info?.['Co-Debtor Supervisor Name'] }}</p>
                        </div>     
                        <div>                          
                          <label style="font-weight: bold;">Co-Debtor Supervisor Number</label>
                          <p class="p-style">{{ collection_info?.['Co-Debtor Supervisor Number'] }}</p>
                        </div>     
                        <div>                          
                          <label style="font-weight: bold;">Co-Debtor Annual Income</label>
                          <p class="p-style">{{ collection_info?.['Co-Debtor Annual Income'] }}</p>
                        </div>       
                        <div *ngIf="coAppEmergencySubForm">                          
                          <label style="font-weight: bold;">Co-Debtor Emergency Contact</label>
                          <p class="p-style">{{ collection_info?.['CoAppEmergencyContact'] | uppercase}}</p>
                        </div>      
                        <div *ngIf="!coAppEmergencySubForm">                          
                          <label style="font-weight: bold;">Co-Debtor Emergency Name</label>
                          <p class="p-style">{{ collection_info?.['Co-Debtor Emergency Name'] }}</p>
                        </div>    
                        <div *ngIf="!coAppEmergencySubForm">                          
                          <label style="font-weight: bold;">Co-Debtor Emergency Number</label>
                          <p class="p-style">{{ collection_info?.['Co-Debtor Emergency Number'] }}</p>
                        </div>       
                        <div *ngIf="!coAppEmergencySubForm">                          
                          <label style="font-weight: bold;">Co-Debtor Emergency Relation</label>
                          <p class="p-style">{{ collection_info?.['Co-Debtor Emergency Relation'] }}</p>
                        </div>       
                        <div *ngIf="!coAppEmergencySubForm">                          
                          <label style="font-weight: bold;">Co-Debtor Employment Email</label>
                          <p class="p-style">{{ collection_info?.['Co-Debtor Employment Email'] }}</p>
                        </div> 
                        </div>            
                      </mat-card-content>
                    </mat-card> 
              </div>
            </mat-tab>
            <mat-tab label="Payments">
              <app-payment-report-loan-servicing [loanNumber]="collection_info?.Loan_Number"
                [acctref]="collection_info?.acctrefno"></app-payment-report-loan-servicing>
            </mat-tab>
            <mat-tab label="Promise to Pay">
              <ng-template matTabContent>
                <app-promise-to-pay-panel [acctrefno]="collection_info?.acctrefno"
                  [loanNumber]="collection_info?.Loan_Number" [customerName]="collection_info?.Name"
                  [meta]="meta" [loanGroupNo]="collection_info?.loan_group_no"></app-promise-to-pay-panel>
              </ng-template>
            </mat-tab>
            <mat-tab label="Deferred">
                  <ag-grid-angular style="width: 100%; height: 700px" class="ag-theme-material" [rowData]="rowData_Def"
                    [columnDefs]="columnDefs_Def" [defaultColDef]="defaultColDef_Def" [animateRows]="true"
                    [pagination]="true" [paginationPageSize]="20" (gridReady)="onGridReady_Def($event)"
                    [getRowStyle]="getRowStyle_Def">
                  </ag-grid-angular>
            </mat-tab>
            <mat-tab label="Future Payments">              
                <ng-template *ngIf="!openAmoFlag" matTabContent>
                  <app-amo-schedule [openAmoFlag]="openAmoFlag" [acctrefno]="collection_info?.acctrefno"></app-amo-schedule>
                </ng-template>
                <app-amo-schedule [openAmoFlag]="openAmoFlag" [acctrefno]="collection_info?.acctrefno"></app-amo-schedule>
            </mat-tab>
          </mat-tab-group>
        </div>
      </div>
    </div>

  </div>
</div>